import { Injectable } from '@angular/core'; // adjust path if needed
import { DataProducts } from './products/data-products.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class DataProductsService {
 
  dataProducts: DataProducts[] = [];
  itemsPerPage = 10;
   p: number = 1;
   headerSubject:BehaviorSubject<any>=new BehaviorSubject<any>(false)
   constructor(private http: HttpClient) { 
    try {
      if (typeof window !== 'undefined') {
        const cached = localStorage.getItem('dataProducts');
        if (cached) this.dataProducts = JSON.parse(cached);
      }
    } catch (err) {
      console.log('LocalStorage not available or JSON error:', err);
    }
  }

  // setDashboards(data: DataProducts[]) {
  //   this.dataProducts = data;
  // }

  // getDashboardById(id: number): DataProducts | undefined {
  //   return this.dataProducts.find(d => d.id === id);
  // }

  // getAllDashboards(): DataProducts[] {
  //   return this.dataProducts;
  // }
  markUnmarkPinned(payload: any) {
      return this.http.post(`${environment.apiUrl}/v1/pinUnpinRequest`, payload);
  }

  //My Reports Services
   statusTilesWithCount(userId: string) {
      let headers = new HttpHeaders().append('userId', userId.toString());
      const requestOptions = { headers: headers };
  
      return this.http.post(
        `${environment.apiUrl}/v1/requestStatusCount`,
        null,
        requestOptions
      );
    }
  
    onSearchFilter(searchValue: any, userId: string) {
      let headers = new HttpHeaders().append('userId', userId.toString());
      const requestOptions = { headers: headers };
  
      return this.http.post(
        `${environment.apiUrl}/v1/requestDetailsBySearch?limit=${this.itemsPerPage}&page=${this.p}&searchText=${searchValue}`,
        null,
        requestOptions
      );
    }
  
    onTypeFilter(userId: string) {
      let headers = new HttpHeaders().append('userId', userId.toString());
      const requestOptions = { headers: headers };
  
      return this.http.post(
        `${environment.apiUrl}/v1/modules`,
        null,
        requestOptions
      );
    }
  
    onStatusFilter(userId: string) {
      let headers = new HttpHeaders().append('userId', userId.toString());
      const requestOptions = { headers: headers };
  
      return this.http.post(
        `${environment.apiUrl}/v1/statuses`,
        null,
        requestOptions
      );
    }
  
    onRequestDetailsFilter(filterValues: any) {
      return this.http.post(
        `${environment.apiUrl}/v1/requestDetailsFilter?limit=${this.itemsPerPage}&page=${this.p}`,
        filterValues
      );
    }
  
    onDownloadCall(downloadRequestBody: any, userId: string): Observable<Blob> {
      const requestOptions: Object = {
        userId: userId.toString(),
        'Content-Type': 'application/octet-stream',
      };
  
      return this.http.post<any>(
        `${environment.apiUrl}/v1/downloadLink`,
        downloadRequestBody,
        requestOptions
      );
    }
  
    onDeleteRequestCall(userId: any, requestId: string) {
      return this.http.post<any>(`${environment.apiUrl}/v1/deleteRequest`, {
        userId,
        requestId,
      });
    }
  
    reRunRequest(requestId: any) {
      const authId = localStorage.getItem('id');
      return this.http.post<any>(`${environment.apiUrl}/v1/rerunRequest`, {
        authId,
        requestId
      });
    }
    getRequestList(id: any, itemsPerPage: any, p: any) {
      const userId: any = id.toString();
      let headers = new HttpHeaders().append('userId', userId);
      const requestOptions = { headers: headers };
      return this.http
        .post(
          `${environment.apiUrl}/v1/requests?limit=${itemsPerPage}&page=${p}`,
          null,
          requestOptions
        )
    }
    getTotalReports(userId: string, headerId: string) {
      let headers = new HttpHeaders()
        .append('userId', userId.toString())
        .append('headerId', headerId.toString());
      const requestOptions = { headers: headers };
  
      return this.http.post(
        `${environment.apiUrl}/v1/totalReports`,
        null,
        requestOptions
      );
    }
}
